import { FC, ReactElement } from 'react'

import { useGetCryptoCurrencyNameById } from 'components/features/rewards/rewardsPane/hooks/useGetCryptoCurrencyNameById'
import { CryptoCurrencyId } from 'components/features/rewards/rewardsPane/types/cryptoCurrency'

type CryptoCurrencyNameByIdProps = {
  currencyId: CryptoCurrencyId | null
}

export const CryptoCurrencyNameById: FC<CryptoCurrencyNameByIdProps> = ({
  currencyId,
}): ReactElement | null => {
  const currencyNameOrNull: string | null = useGetCryptoCurrencyNameById(currencyId)
  return <>{ currencyNameOrNull }</> ?? null
}
